import { render } from "./MyFeedback.vue?vue&type=template&id=0ef4f5a2&scoped=true"
import script from "./MyFeedback.vue?vue&type=script&lang=js"
export * from "./MyFeedback.vue?vue&type=script&lang=js"

import "./MyFeedback.vue?vue&type=style&index=0&id=0ef4f5a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef4f5a2"]])

export default __exports__